<template>
  <div v-if="! isLoading">
    <div v-if="isText">
      <div v-if="isFavorite" class="text-orange focus:outline-none text-14">
        <i class="fas fa-heart"></i>
        ADDED TO FAVORITES
      </div>

      <button v-else @click="checkAuthentication" class="text-orange focus:outline-none text-14">
        <i class="fal fa-heart"></i>
        ADD TO FAVORITES
      </button>
    </div>

    <div v-else>
      <button v-if="isFavorite" @click="removeToFavorites"
              :class="isBox ? 'rounded' : 'rounded-full'"
              class="font-bold uppercase focus:outline-none text-white bg-orange lg:leading-1.25 py-8 px-8 flex
            border-orange justify-between cursor-pointer items-center lg:border-2 shadow-md lg:shadow-none">
        <i class="fas fa-heart"></i>
      </button>

      <button v-else @click="checkAuthentication"
              class="font-bold uppercase focus:outline-none lg:leading-1.25 py-8 px-8 flex justify-between cursor-pointer
            items-center border-2 shadow-md lg:shadow-none bg-transparent button-container transform
            lg:hover:-translate-y-4 transition duration-300 text-orange hover:text-white hover:bg-orange border-orange"
              :class="isBox ? 'rounded' : 'rounded-full'"
              :disabled="isDisabled">
        <i v-if="isFavorite" class="fas fa-heart"></i>

        <div v-else>
          <i class="fas fa-heart solid-icon"></i>
          <i class="far fa-heart font-bolder outline-icon"></i>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "FavoriteButton",

  props: {
    artwork: {
      required: true,
    },
    isBox: {
      type: Boolean,
      default: false,
    },
    isText: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      isLoading: true,
      isDisabled: false,
      isFavorite: false,
      api: '/web/api/artworks/favorite/',
      buttonNotificationSettings: {
        type: 'link',
        href: '/favorites',
        text: 'View',
        displayMobile: true,
      }
    }
  },


  created() {
    axios.get(this.api + this.artwork.slug)
      .then(({data}) => {
        this.isFavorite = data.isFavorite
        this.isLoading = false
      })
  },

  methods: {
    toggleNotification (data) {
      this.$root.$refs.notification.notify({
        title: data.title,
        message: data.message,
        buttonSettings: this.buttonNotificationSettings,
        type: 'warning-dark',
      })
    },

    addToFavorites () {
      axios.post(this.api, {artworkSlug: this.artwork.slug})
        .then(({ data }) => {
          this.isFavorite = true
          this.buttonNotificationSettings.type = 'link'
          this.buttonNotificationSettings.text = 'View'
          this.toggleNotification(data)

          window.dataLayer.push({
            event: 'add-to-favorite',
            id: this.artwork.slug,
            title: this.artwork.title,
            price: this.artwork.discounted_price ?? this.artwork.original_price,
          })

          window.TheFavoriteLink.increment()
        })
    },

    removeToFavorites () {
      let data = {artworkSlug: this.artwork.slug};
      axios.delete(this.api, {data: data})
        .then(({ data }) => {
          this.$favoriteArtwork.$emit('remove', this.artwork)
          this.isFavorite = false
          this.buttonNotificationSettings.type = 'button'
          this.buttonNotificationSettings.text = 'close'
          this.toggleNotification(data)
        })
    },

    checkAuthentication () {
      axios.get('/web/api/subscribe/show')
        .then((success) => {
          this.addToFavorites()
        })
        .catch((error) => {
          if (error.response.status === 403) {
            let parameter = {favorite_artwork: this.artwork.slug}
            let header = `To add "${this.artwork.title}" to your favorites, sign in to drybrush Gallery`
            this.$root.$refs.signInModal.toggle(parameter, header)
          }
        })
    },
  }
}
</script>

<style scoped>
.outline-icon {
  display: block;
}

.solid-icon {
  display: none;
}

.button-container:hover .solid-icon {
  display: block;
}

.button-container:hover .outline-icon {
  display: none;
}
</style>
